import { Vue as _Vue } from 'vue/types/vue'
import { VueModule } from 'vue-modules'
import VueRouter from 'vue-router'
import { Store } from 'vuex'
import vuetify from '../../plugins/vuetify'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import App from './components/App.vue'
import {SnackbarStore} from '@/modules/core/store';

export class CoreModule implements VueModule {
  readonly name = 'core';
  public vue: any;
  constructor (private router: VueRouter, private store: Store<any>) {}
  install (Vue: typeof _Vue) {

    //ref https://vuex.vuejs.org/guide/modules.html#dynamic-module-registration
    //this.store.registerModule([this.name, "error"], SnackbarStore);

    this.vue = new Vue({
      router: this.router,
      store: this.store,
      vuetify,
      render: h => h(App)
    }).$mount('#app');

    Vue.use(TiptapVuetifyPlugin, {
      // ref https://github.com/iliyaZelenko/tiptap-vuetify
      vuetify,
      iconsGroup: 'mdi'
    });
  }
}
